import "reflect-metadata";
import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "@app/app.component";
import { appConfig } from "@app/app.config";
import { INDEXED_DB_CONFIG } from "@app/indexed-db-config";
import { alignIndexedDbVersion } from "@app/indexed-db-version";
import * as Sentry from "@sentry/angular";

import "./polyfills";

import { environment } from "@environments/environment";
import "@angular/localize/init";

// Redirect to Front Door URL if not already there, to ensure old links still work
if (environment.frontdoorUrl && !window.location.href.startsWith(environment.frontdoorUrl)) {
  window.location.href = environment.frontdoorUrl + window.location.pathname + window.location.hash;
}

if (environment.production) {
  enableProdMode();
}

if (environment.googleTagManagerId?.length) {
  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = "https://www.googletagmanager.com/gtag/js?id=" + environment.googleTagManagerId;

  const script2 = document.createElement("script");
  script2.innerHTML =
    'window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag("js", new Date());gtag("config", "' +
    environment.googleTagManagerId +
    '");';

  document.head.appendChild(script1);
  document.head.appendChild(script2);
}

initSentry();
// Must run before bootstrapApplication(): a stale PWA bundle's configured DB version can be lower than the
// version already present on disk, which would otherwise throw a VersionError and make the whole app
// unusable. alignIndexedDbVersion() never throws/rejects, so it cannot make the bootstrap itself fail.
alignIndexedDbVersion(INDEXED_DB_CONFIG).finally(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});

function initSentry() {
  if (environment.sentryEnvironment && environment.sentryIngestUrl) {
    Sentry.init({
      dsn: environment.sentryIngestUrl,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.3,
      tracePropagationTargets: ["https://navintastagingstorage.z6.web.core.windows.net", "https://navinta.draeger.net", "https://navintaprodstorage.z6.web.core.windows.net", "http://localhost:4200"],
      environment: environment.sentryEnvironment,
    });
  }
}
